import PubSub from "underpub-js";

var ListingCommunities = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingCommunities',
	};

	$.extend(true, this.options, options);

};

ListingCommunities.prototype.init = function() {

	var self = this;

};

export default ListingCommunities;
